import React, { useState, useEffect } from "react";
// import "../../components/Profile/Profile.css";
// import image from "../../images/vishal.jpg";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import axios from "axios";
import AirFrieghtDomesticMaster from "../../pages/AirFrieghtDomesticMaster/AirFrieghtDomesticMaster";

const AirFrieghtDomestic = ({ tokenStorage,openProfile,setOpenProfile,selectedTseedID, setSuccessMessage }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [employeeDetailResponse, setEmployeeDetailResponse] = useState([]);
  const [departmentResponse, setDepartmentResponse] = useState([]);
  const [designationDetailResponse, setDesignationResponse] = useState([]);
  const [regionDetailResponse, setRegionDetailResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [isEmailValid, setIsEmailValid] = useState(true);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const [firstItem, setFirstItem] = useState({
    Tseed:"",
    Origin_Code: "",
    Destination_Code: "",
    Lane: "",
    Prime_GCR_Lean_SCR: "",
    MIN: "",
    Normal: "",
    PER_KG_RATE: "",
    AVI_HANDLING: "",
    DDC: "",
    FLC: "",
    XRAY: "",
    XRAY_MIN: "",
    HCC: "",
    HCC_MIN: "",
    OUT_XCC: "",
    XCC_MIN: "",
    OUT_TSP: "",
    OUT_TSP_MIN: "",
    IN_TSP: "",
    IN_TSP_MIN: "",
    created_Date: "",
  });

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetAirFreightDomestic?Tseed=`+selectedTseedID+`&Origin_Code=&Destination_Code=&Lane=` 
          ,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {          
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching employee detail:", error);
        });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (name === "email") {
    //   // Use a simple check for email validity
    //   const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    //   setIsEmailValid(isValid);
    // }
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    
    setFirstItem((prevItem) => ({
      ...prevItem,
      Tseed: selectedTseedID,
    }));

    // if (!isEmailValid) {
    //   // Optionally, you can display an error message or handle it in any way you prefer.
    //   console.error("Invalid email address");
    //   return;
    // }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      
      const response = await axios.post(
        `${baseAPI}adminpost/AddEmployee`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      

      //to show success message
      setSuccessMessage("Data successfully saved");

      // Optionally, reset the form
      setFirstItem({
        Tseed:"",
        Origin_Code: "",
        Destination_Code: "",
        Lane: "",
        Prime_GCR_Lean_SCR: "",
        MIN: "",
        Normal: "",
        PER_KG_RATE: "",
        AVI_HANDLING: "",
        DDC: "",
        FLC: "",
        XRAY: "",
        XRAY_MIN: "",
        HCC: "",
        HCC_MIN: "",
        OUT_XCC: "",
        XCC_MIN: "",
        OUT_TSP: "",
        OUT_TSP_MIN: "",
        IN_TSP: "",
        IN_TSP_MIN: "",
        created_Date: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  // -----------------------------department & Designation-----------------------
  // useEffect(() => {
  //   const storedToken = JSON.parse(localStorage.getItem("token"));
  //   //console.log(storedToken);

  //   if (storedToken) {
  //     axios
  //       .get(
  //         `${baseAPI}adminget/GETDepartment?department=0`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${storedToken}`,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         //console.log(response.data.data);
  //         setDepartmentResponse(response.data.data);
  //         updateDesignation("0");
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching user detail:", error);
  //       });
  //   }
  // }, []);

  // const handleSelectChange = (event) => {
  //   handleChange(event);
  //   updateDesignation(event.target.value);
  // };

  // const updateDesignation = (dept) => {
  //   const storedToken = JSON.parse(localStorage.getItem("token"));
  //   //console.log(storedToken);

  //   if (storedToken) {
  //     axios
  //       .get(
  //         `${baseAPI}adminget/GETDesignation?designation=0&department=` +
  //         dept,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${storedToken}`,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         //console.log(response.data.data);
  //         setDesignationResponse(response.data.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching user detail:", error);
  //       });
  //   }
  // };

  // useEffect(() => {
  //   const storedToken = JSON.parse(localStorage.getItem("token"));
  //   //console.log(storedToken);

  //   if (storedToken) {
  //     axios
  //       .get(`${baseAPI}Adminget/GETRegion?region_id=0`, {
  //         headers: {
  //           Authorization: `Bearer ${storedToken}`,
  //         },
  //       })
  //       .then((response) => {
  //         //console.log(response.data.data);
  //         setRegionDetailResponse(response.data.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching user detail:", error);
  //       });
  //   }
  // }, []);

  return (
    <div className="container-fluid">
      <br />

      <div className="employeeDetail">
        {/* {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )} */}
        <div className="employeeDetailHeader">
          <div className="employeeNameAndImage">
          <div style={{ borderRadius: '50%', overflow: 'hidden', backgroundColor: 'white' }}>
    <PersonOutlineIcon />
</div>

            <div className="employeeName">
              <h1 style={{ fontSize: "25px" }}>{firstItem.Name}</h1>
              <span style={{ color: "#878787" }}>
                {firstItem.department}
              </span>
            </div>
          </div>

          <div className="ClearTab">
            <button
              onClick={handleSubmit}
              className={isEditMode ? "saveButton" : "closeTabButton"}
            >
              {isEditMode ? "Save" : "Close Tab"}
            </button>
            <button
              className={isEditMode ? "CancelButton" : "editButton"}
              onClick={toggleEditMode}
            >
              {/* Edit {isEditMode ? "" : ""} */}
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </div>
        </div>

        {/* ---------------------------------------------------------------------------------------------------------------- */}
        {isEditMode ? (
          // --------------Edit mode---------------//
          <form className="employee-form" onSubmit={handleSubmit}>
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Origin Code</td>
                <td>Destination Code</td>
                <td>Lane</td>
                <td>Prime/GCR/LEAN/SCR</td>
              </tr>

              <tr>
                <td>
                  <input
                    name="firstName"
                    value={firstItem.Origin_Code}
                    onChange={handleChange}
                  />
                </td>
                <td>
                  <input
                    name="lastName"
                    value={firstItem.Destination_Code}
                    onChange={handleChange}
                  />
                </td>
                <td>
                  <input
                    name="Lane  "
                    value={firstItem.Lane}
                    onChange={handleChange}
                  />
                </td>
                <td style={{ color: "#28A745" }}>
                <input
                    name="lastName"
                    value={firstItem.Prime_GCR_Lean_SCR}
                    onChange={handleChange}
                  />


                  {/* <select
                    className="dropdown-employee"
                    name="is_active"
                    value={firstItem.Lane}
                    onChange={handleChange}
                  >
                    <option
                      className="dropdown-employee"
                      style={{ color: "grey" }}
                      value="0"
                    >
                      Please select
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select> */}
                </td>
              </tr>
              <tr className="space">
                <td colSpan={4}></td>
              </tr>
              <tr className="tableHeading">
                <td>MIN</td>
                <td> Normal</td>
                <td>Per kg Rate</td>
                <td>AVI hHandling</td>
              </tr>

              <tr>
             
                <td style={{ color: "#28A745" }}>
                <input
                    name="MIN"
                    value={firstItem.MIN}
                    onChange={handleChange}
                  />
                  </td>
                  <td style={{ color: "#28A745" }}>
                <input
                    name="MIN"
                    value={firstItem.Normal}
                    onChange={handleChange}
                  />
                  </td>
                  <td style={{ color: "#28A745" }}>
                <input
                    name="PER_KG_RATE"
                    value={firstItem.PER_KG_RATE}
                    onChange={handleChange}
                  />
                  </td>
                  <td style={{ color: "#28A745" }}>
                <input
                    name="AVI_HANDLING"
                    value={firstItem.AVI_HANDLING}
                    onChange={handleChange}
                  />
                  </td>
                  
                  {/* <select
                    className="dropdown-employee"
                    name="gender"
                    value={firstItem.gender}
                    onChange={handleChange}
                  >
                    <option
                      className="dropdown-employee"
                      style={{ color: "grey" }}
                      value=""
                    >
                      Please Select*
                    </option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Other</option>
                  </select> */}
                
                {/* <td>
                  <input
                    name="email"
                    value={firstItem.email}
                    onChange={handleChange}
                  />
                  {!isEmailValid && (
                  <span style={{ color: "red" }}>Invalid email address</span>
                )}
                </td>
                <td>
                  <input
                    name="phoneNo"
                    value={firstItem.phoneNo}
                    onChange={handleChange}
                  />
                </td> */}
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>DDC</td>
                <td>FLC</td>
                <td>X-RAY</td>
                <td>X-RAY/MIN</td>
              </tr>

              <tr>
                <td>

                <input
                    name="DDC"
                    value={firstItem.DDC}
                    onChange={handleChange}
                  />
                  {/* <select
                    className="dropdown-employee"
                    name="dept_id"
                    value={firstItem.DDC}
                    onChange={handleSelectChange}
                    style={{ height: "29px", width: "13rem" }}
                  >
                    <option value="">Select an option</option>
                    {departmentResponse.map((item) => (
                      <option value={item.dept_id}>{item.department}</option>
                    ))}
                  </select> */}
                </td>
                <td>
                  {/* <select
                    className="dropdown-employee"
                    name="desg_id"
                    value={firstItem.desg_id}
                    onChange={handleChange}
                    style={{ height: "29px", width: "13rem" }}
                  >
                    <option value="" style={{ width: "5rem" }}>
                      Select an option
                    </option>
                    {designationDetailResponse.map((item) => (
                      <option value={item.desg_id}>{item.designation}</option>
                    ))}
                  </select> */}
                   <input
                    name="FLC"
                    value={firstItem.FLC}
                    onChange={handleChange}
                  />
                </td>
                <td>
                  {/* <select
                    name="region"
                    value={firstItem.region}
                    onChange={handleChange}
                    style={{ height: "29px", width: "13rem" }}
                  >
                    <option value="">Select an option</option>
                    {regionDetailResponse.map((item) => (
                      <option value={item.region_id}>{item.region_name}</option>
                    ))}
                  </select> */}
                  <input
                    name="FLC"
                    value={firstItem.XRAY}
                    onChange={handleChange}
                  />
                  
                </td>
              <td>
              <input
                    name="XRAY_MIN"
                    value={firstItem.XRAY_MIN}
                    onChange={handleChange}
                  />

                </td>
              
              </tr>
              <tr className="space">
                <td colSpan={4}></td>
              </tr>
              <tr className="tableHeading">
                <td>OUT XCC</td>
                <td>OUT TSP</td>
                <td>IN TSP</td>
              </tr>
              <tr> <td style={{ color: "#28A745" }}>

              <input
                    name="HCC"
                    value={firstItem.OUT_XCC}
                    onChange={handleChange}
                  />
                
                
              </td>
              <td>
              <input
                    name="OUT_TSP"
                    value={firstItem.OUT_TSP}
                    onChange={handleChange}
                  />
              </td>
              <td>
              <input
                    name="IN_TSP"
                    value={firstItem.IN_TSP}
                    onChange={handleChange}
                  />
              </td>
              
              </tr>

            </table>
          </form>
        ) : (
          // --------------Display mode---------------//
          <div>
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Origin Code</td>
                <td>Destination Code</td>
                <td>Lane</td>
                <td>Prime/GCR/LEAN/SCR</td>
              </tr>

              <tr>
                <td>{firstItem.Origin_Code}</td>
                <td>{firstItem.Destination_Code}</td>
                <td style={{ color: "#28A745" }}>{firstItem.Lane}</td>
                <td>{firstItem.Prime_GCR_Lean_SCR}</td>
              </tr>
              <tr className="space">
                <td colSpan={4}></td>
              </tr>
              <tr className="tableHeading">
                <td>MIN</td>
                <td> NORMAL</td>
                <td>Per KG Rate</td>
                <td>AVI Handling</td>
              </tr>

              <tr>
                <td>{firstItem.MIN}</td>
                <td>{firstItem.Destination_Code}</td>
                <td>{firstItem.Lane}</td>
                <td>{firstItem.AVI_HANDLING}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>DDC</td>
                <td>FLC</td>
                <td>X-Ray</td>
                <td>HCC</td>
              </tr>

              <tr>
                <td>{firstItem.DDC}</td>
                <td>{firstItem.FLC}</td>
                <td>{firstItem.XRAY}</td>
                <td>{firstItem.XRAY_MIN}</td>
              </tr>
              <tr className="space">
                <td colSpan={4}></td>
              </tr>
              <tr className="tableHeading">
                <td>HCC</td>
                <td>HCC_MIN</td>
                <td>OUT_TSP</td>
                <td>OUT TSP MIN</td>
              </tr>
              <tr>
                <td>{firstItem.HCC}</td>
                <td>{firstItem.HCC_MIN}</td>
                <td>{firstItem.OUT_TSP}</td>
                <td>{firstItem.OUT_TSP_MIN}</td>
                
              </tr>


            </table>
          </div>
        )}
      </div>

      <br />
    </div>
  );
};

export default AirFrieghtDomestic;
